<template>
    <form name="checkout" :class="{loader: $store.getters.loading}" method="post" class="checkout-form" action="#" enctype="multipart/form-data">
        <notifications></notifications>
        <div class="row">
            <div class="col-md-6 mb-3 mb-md-0">
                <div class="billing-fields">
                    <h3>Billing details</h3>
                    <div class="billing-fields__wrapper">
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="form_row">
                                    <label>First Name<span class="required">*</span></label>
                                    <input
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        v-on:change="handleInputChange"
                                        :class="{invalid: errors.billing_first_name}"
                                        v-model="billing_info.billing_first_name"
                                        v-on:focusout="billing_info.billing_first_name = capitalizeWords($event)"
                                        >
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <p class="form_row">
                                    <label class="">Last Name<span class="required">*</span></label>
                                    <input
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        :class="{invalid: errors.billing_last_name}"
                                        v-on:change="handleInputChange"
                                        v-model="billing_info.billing_last_name"
                                        v-on:focusout="billing_info.billing_last_name = capitalizeWords($event)"
                                        >
                                </p>
                            </div>
                        </div>

                        <p class="form_row">
                            <label class="">Company Name&nbsp;<span class="optional">(optional)</span></label>
                            <input
                                type="text"
                                class="input-text text-capitalize"
                                autocapitalize="words"
                                v-on:change="handleInputChange"
                                :class="{invalid: errors.billing_company_name}"
                                v-model="billing_info.billing_company_name"
                                v-on:focusout="billing_info.billing_company_name = capitalizeWords($event)">
                        </p>
                        <p class="form_row">
                            <label class="">Country<span class="required">*</span></label>
                            <span class="woocommerce-input-wrapper">
                                                            <strong>United States (US)</strong>
                                                        </span>
                        </p>
                        <p class="form_row">
                            <label class="">Street Address<span class="required">*</span></label>

                            <input
                                type="text"
                                placeholder="House number and street name"
                                class="input-text input-address text-capitalize"
                                autocapitalize="words"
                                :class="{invalid: errors.billing_street_address1}"
                                v-on:change="handleInputChange"
                                v-model="billing_info.billing_street_address1"
                                v-on:focusout="billing_info.billing_street_address1 = capitalizeWords($event)">
                        </p>
                        <p class="form_row">
<!--                            <label class="screen-reader-text">-->
<!--                                Apartment, suite, unit etc.&nbsp;-->
<!--                                <span  class="optional">(optional)</span>-->
<!--                            </label>-->
                            <input
                                type="text"
                                placeholder="Apartment, suite, unit, etc"
                                class="input-text input-address text-capitalize"
                                autocapitalize="words"
                                :class="{invalid: errors.billing_street_address2}"
                                v-on:change="handleInputChange"
                                v-model="billing_info.billing_street_address2"
                                v-on:focusout="billing_info.billing_street_address2 = capitalizeWords($event)">
                        </p>
                        <p class="form_row">
                            <label class="">City<span  class="required">*</span>
                            </label>
                            <input
                                type="text"
                                class="input-text text-capitalize"
                                autocapitalize="words"
                                :class="{invalid: errors.billing_city}"
                                v-on:change="handleInputChange"
                                v-model="billing_info.billing_city"
                                v-on:focusout="billing_info.billing_city = capitalizeWords($event)">
                        </p>
                        <p class="form_row">
                            <label class="">
                                State<span  class="required">*</span>
                            </label>
                            <v-select
                                class="cxecrt-input-text input-address"
                                :options="constants.STATE_LIST" v-model="billing_info.billing_state"
                                v-on:change="handleInputChange"
                                :reduce="state => state.code"
                                :searchable="true"
                                placeholder="State"
                            />

                        </p>
                        <p class="form_row">
                            <label class="">
                                ZIP<span  class="required">*</span>
                            </label>
                            <input
                                type="text"
                                class="input-text"
                                :class="{invalid: errors.billing_zipcode}"
                                v-on:change="handleInputChange"
                                v-model="billing_info.billing_zipcode">
                        </p>
                        <p class="form_row">
                            <label class="">
                                Phone<span class="required">*</span>
                            </label>
                            <input
                                type="text"
                                class="input-text"
                                :class="{invalid: errors.billing_phone_number}"
                                v-on:change="handleInputChange"
                                v-on:input="billing_info.billing_phone_number = phoneInputFormatter($event)"
                                @keypress="numbersOnly"
                                maxlength="14"
                                v-model="billing_info.billing_phone_number">
                        </p>
                        <p class="form_row">
                            <label class="">
                                Email Address<span  class="required">*</span>
                            </label>
                            <input
                                type="text"
                                class="input-text"
                                :class="{invalid: errors.billing_email_address}"
                                v-on:change="handleInputChange"
                                v-model="billing_info.billing_email_address">
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="shipping-fields">
                    <div class="shipping-fields">
                        <h3 id="ship-to-different-address">
                            <label class="label-for-checkbox checkbox mb-0">
                                <span class="shipping-title">Shipping Address</span> <br>
                                <input id="ship-to-different-address-checkbox"
                                       v-model="billing_info.same_as_billing"
                                       class="form__input-checkbox input-checkbox" type="checkbox"
                                       name="ship_to_different_address" checked>
                                <span class="ship-txt" style="cursor: pointer">Same as Billing <span>(Cannot Ship to PO Box)</span></span>
                            </label>
                        </h3>
                        <div class="shipping_address" :class="{notVisible: billing_info.same_as_billing}">
                            <div class="shipping-fields__wrapper">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <p class="form_row">
                                            <label>First Name<span class="required">*</span></label>
                                            <input
                                                type="text"
                                                class="input-text text-capitalize"
                                                autocapitalize="words"
                                                :class="{invalid: errors.shipping_first_name}"
                                                v-model="shipping_info.shipping_first_name"
                                                v-on:focusout="shipping_info.shipping_first_name = capitalizeWords($event)">
                                        </p>
                                    </div>
                                    <div class="col-sm-6">
                                        <p class="form_row">
                                            <label class="">Last Name<span class="required">*</span></label>
                                            <input
                                                type="text"
                                                class="input-text text-capitalize"
                                                autocapitalize="words"
                                                :class="{invalid: errors.shipping_last_name}"
                                                v-model="shipping_info.shipping_last_name"
                                                v-on:focusout="shipping_info.shipping_last_name = capitalizeWords($event)">
                                        </p>
                                    </div>
                                </div>

                                <p class="form_row">
                                    <label class="">Company Name&nbsp;<span class="optional">(optional)</span></label>
                                    <input
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        :class="{invalid: errors.shipping_company_name}"
                                        v-model="shipping_info.shipping_company_name"
                                        v-on:focusout="shipping_info.shipping_company_name = capitalizeWords($event)">
                                </p>
                                <p class="form_row">
                                    <label class="">Country<span class="required">*</span></label>
                                    <span  class="woocommerce-input-wrapper">
                                                            <strong>United States (US)</strong>
                                                        </span>
                                </p>
                                <p class="form_row">
                                    <label class="">Street Address<span class="required">*</span></label>

                                    <input
                                        placeholder="House number and street name"
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        :class="{invalid: errors.shipping_street_address1}"
                                        v-model="shipping_info.shipping_street_address1"
                                        v-on:focusout="shipping_info.shipping_street_address1 = capitalizeWords($event)">
                                </p>
                                <p class="form_row">
<!--                                    <label class="screen-reader-text">-->
<!--                                        Apartment, suite, unit etc.&nbsp;-->
<!--                                        <span  class="optional">(optional)</span>-->
<!--                                    </label>-->
                                    <input
                                        placeholder="Apartment, suite, unit etc."
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        :class="{invalid: errors.shipping_street_address2}"
                                        v-model="shipping_info.shipping_street_address2"
                                        v-on:focusout="shipping_info.shipping_street_address2 = capitalizeWords($event)">
                                </p>
                                <p class="form_row">
                                    <label class="">City<span  class="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        class="input-text text-capitalize"
                                        autocapitalize="words"
                                        :class="{invalid: errors.shipping_city}"
                                        v-model="shipping_info.shipping_city"
                                        v-on:focusout="shipping_info.shipping_city = capitalizeWords($event)">
                                </p>
                                <p class="form_row">
                                    <label class="">
                                        State<span  class="required">*</span>
                                    </label>
                                    <v-select
                                        class="cxecrt-input-text"
                                        :options="constants.STATE_LIST" v-model="shipping_info.shipping_state"
                                        :reduce="state => state.code"
                                        :searchable="true"
                                        placeholder="State"
                                    />

                                </p>
                                <p class="form_row">
                                    <label class="">
                                        ZIP<span  class="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        class="input-text"
                                        :class="{invalid: errors.shipping_zipcode}"
                                        v-model="shipping_info.shipping_zipcode">
                                </p>
                                <p class="form_row">
                                    <label class="">
                                        Phone<span class="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        class="input-text"
                                        :class="{invalid: errors.shipping_phone_number}"
                                        v-on:input="shipping_info.shipping_phone_number = phoneInputFormatter($event)"
                                        @keypress="numbersOnly"
                                        maxlength="14"
                                        v-model="shipping_info.shipping_phone_number">
                                </p>
                                <p class="form_row">
                                    <label class="">
                                        Email Address<span  class="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        class="input-text"
                                        :class="{invalid: errors.shipping_email_address}"
                                        v-model="shipping_info.shipping_email_address">
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="additional-fields">
                        <div class="additional-fields__wrapper">
                            <p class="form_row notes" id="order_comments_field">
                                <label class="">
                                    Order Notes&nbsp;
                                    <span class="optional">(optional)</span>
                                </label>
                                <textarea
                                    class="input-text"
                                    id="textarea_word_count"
                                    :class="{invalid: errors.order_notes}"
                                    v-model="billing_info.order_notes"
                                    placeholder="Notes about your order, e.g. special notes for delivery."
                                    rows="12" cols="10" maxlength="1024"></textarea>
                                    <div id="charCount" style="font-size: 14px;margin-top: -3px;">Character Count: 0/1024</div>
                            </p>
                        </div>
                        <input type="hidden" class="input-hidden same_as_billing_fix"
                               name="ship_to_different_address" value="1"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <order-summary></order-summary>

                <div id="payment" class="checkout-payment">
                    <p class="form_row term_and_conditions">
                        <label class="label-for-checkbox checkbox">
                            <input type="checkbox" class="input-checkbox" v-model="billing_info.read_and_accept" name="terms" value="1" checked="checked" id="terms">
                            <span class="terms-and-conditions-checkbox-text"><span>I Have Read and Agree to All</span>
                                <a href="about/terms-conditions/" class="terms-and-conditions-link text-decoration-underline" target="_blank">
                                    Terms and Conditions
                                </a><span> of this Website</span><span class="required">*</span></span>&nbsp;
                        </label>
                    </p>
                    <h3 class="payment-options-title d-none d-sm-block" v-if="$store.getters.totalPrice > 0">Payment options</h3>
                    <h3 class="payment-options-title d-sm-none mt-5" v-if="$store.getters.totalPrice > 0">CHOOSE PAYMENT METHOD</h3>
                    <div class="form_row place-order col-sm-12 ml-sm-auto">
                        <div class="payment-content accordion"  id="accordionPayment">
                            <div class="payment-accordion-box" v-if="configs.usaepay.active && $store.getters.totalPrice > 0">
                                <label id="headingOne" @click="submitButtonVisible('credit_cart')" class="collapsed" data-toggle="collapse" data-target="#paymentOne" aria-expanded="true"  aria-controls="paymentOne">Credit/Debit Card</label>
                                <div class="payment-accordion-form collapse" id="paymentOne" aria-labelledby="headingOne" data-parent="#accordionPayment">
                                    <div class="w-100">
                                        <span>Card Number <sup>*</sup></span>
                                        <input inputmode="numeric"  v-model="payment_details.card_number" class="cc-number" autocomplete="cc-number" autocorrect="no" autocapitalize="no" spellcheck="no" type="tel" placeholder="•••• •••• •••• ••••">
                                    </div>
                                    <div class="w-50 d-inline-block">
                                        <span>Expiration Date <sup>*</sup></span>
                                        <input inputmode="numeric" v-model="payment_details.card_expiration_date" class="cc-expiry" autocomplete="cc-exp" autocorrect="no" autocapitalize="no" spellcheck="no" type="tel" placeholder="MM / YY">
                                    </div>
                                    <div class="w-25 ml-4 d-inline-block">
                                        <span>Security Code <sup>*</sup></span>
                                        <input inputmode="numeric" v-model="payment_details.card_security_Code" class="cc-cvc" autocomplete="off" autocorrect="no" autocapitalize="no" spellcheck="no" type="number" placeholder="CVC" style="width:100px">
                                    </div>
                                </div>
                            </div>
                            <div class="payment-accordion-box" v-if="configs.paypal.active && $store.getters.totalPrice > 0">
                                <div class="collapse show" id="paymentTwo" aria-labelledby="headingTwo" data-parent="#accordionPayment">
                                   <Paypal-button></Paypal-button>
                                </div>
                            </div>

                            <a href="javascript:" v-if="submitVisible" v-on:click="submitOrder" class="checkout_btn tn_btn_red text-center" id="place_order">Submit Order</a>
                            <img loading="lazy"  src="/images/badge/Trust-Badges-Graphic.png" alt="Trust Badges" class="trust-badges-img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>


<script>
import {mapActions, mapState} from "vuex";


import PaypalButton from "../PaypalButton";
import vSelect from "vue-select";
import OrderSummary from "./OrderSummary";
import Notifications from "../Notifications";
export default {
    name: 'checkout-form',
    props: ['propConfigs', 'propAppendurl', 'propSharedcarthash', 'propHashshared'],
    components: {Notifications, OrderSummary, PaypalButton, 'v-select': vSelect},
    data() {
        return {
            submitVisible: true,
            payment_details: {
                card_number: null,
                card_expiration_date: null,
                card_security_Code: null
            },
            configs: JSON.parse(this.propConfigs),
            failedOrder: null,
            appendurl: this.propAppendurl,
            sharedcarthash: this.propSharedcarthash,
            hashshared: this.propHashshared,
        }
    },
    computed: {
        ...mapState(['billing_info', 'shipping_info']),
        errors() {
            return this.$store.getters.validationErrors
        },
    },
    methods: {
        ...mapActions(['saveCart', 'removeCart', 'emptyNotes', 'emptyCart', 'addNote', 'loading', 'calcGroundFreight', 'removeCoupon', 'clearSharedCartHash','checkCartItems']),
        async submitOrder() {
            this.loading(true)
            this.emptyNotes()
            await this.checkCartItems();
            // this.loading(true)

            if(this.$store.state.cart.items && this.$store.state.cart.items.length > 0)
            {

                if(this.$store.getters.totalPrice > 0)
                {
                    // this.payment_details.card_expiration_date = this.payment_details?.card_expiration_date?.replace(' / ', '')
                    this.billing_info.billing_phone_number = this.billing_info?.billing_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    this.shipping_info.shipping_phone_number = this.shipping_info?.shipping_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    await axios.post('/usaupay/set-express-checkout', {
                        ...this.$store.getters.expressCheckoutRequest,
                        ...{payment_details: this.payment_details},
                        ...{payment_type: 'usaepay'},
                        ...{order_page: window.sabmitOrderPage},
                        ...{failed_order: this.failedOrder},
                        ...{coupon: this.$store.getters.coupon},
                        ...{hash: this.$store.getters.cartHash},
                        ...{shared_cart_hash: this.$store.state.cart.sharedCartHash},
                    }).then(orderData => {
                        axios.post('/usaupay/order/capture', {order: orderData}).then(({data}) => {
                            if(data.status === 'success') {
                                if(this.$store.getters.coupon)
                                {
                                    this.removeCoupon()
                                }
                                this.clearSharedCartHash()
                                this.emptyCart().then(res => {
                                    this.removeCart()
                                })
                                window.location.href = data.redirect
                            }
                            this.loading(true)
                        })
                    }).catch(errors => {

                        if (errors.response && errors.response.status === 422 && errors.response.data) {
                            const errs = []
                            for (const item in errors.response.data.errors) {
                                errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                            }
                            this.addNote({items: errs})
                        }

                        let value = this.billing_info.billing_phone_number
                        if (value && value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.billing_info.billing_phone_number = value

                        value = this.shipping_info.shipping_phone_number
                        if (value && value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.shipping_info.shipping_phone_number = value

                        if (errors.response && errors.response.status === 500 && errors.response.data) {
                            for(let i = 0; i < errors.response.data.messages.length; i++) {
                                this.addNote({item: {message: errors.response.data.messages[i], type: 'error'}})
                            }
                            this.failedOrder = errors.response.data.order
                        }
                        this.loading(false)
                        return null
                    })
                }
                else
                {
                    this.billing_info.billing_phone_number = this.billing_info?.billing_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    this.shipping_info.shipping_phone_number = this.shipping_info?.shipping_phone_number?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
                    await axios.post('/submit-order/set-checkout', {
                        ...this.$store.getters.expressCheckoutRequest,
                        ...{payment_details: this.payment_details},
                        ...{payment_type: 'submit'},
                        ...{order_page: window.sabmitOrderPage},
                        ...{failed_order: this.failedOrder},
                        ...{coupon: this.$store.getters.coupon},
                        ...{hash: this.$store.getters.cartHash},
                        ...{shared_cart_hash: this.$store.state.cart.sharedCartHash},
                    }).then(orderData => {
                        axios.post('/submit/order/capture', {order: orderData}).then(({data}) => {
                            if(data.status === 'success') {
                                if(this.$store.getters.coupon)
                                {
                                    this.removeCoupon()
                                }
                                this.clearSharedCartHash()
                                this.emptyCart().then(res => {
                                    this.removeCart()
                                })
                                window.location.href = data.redirect
                            }
                            this.loading(true)
                        })
                    }).catch(errors => {

                        if (errors.response && errors.response.status === 422 && errors.response.data) {
                            const errs = []
                            for (const item in errors.response.data.errors) {
                                errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                            }
                            this.addNote({items: errs})
                        }

                        let value = this.billing_info.billing_phone_number
                        if (value && value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.billing_info.billing_phone_number = value

                        value = this.shipping_info.shipping_phone_number
                        if (value && value.length >= 3 && !value.includes('(') && !value.includes(')') ) {

                            let phoneCode = value.slice(0, 3)
                            let phoneNumber = value.replace(phoneCode, ' ')
                            value = `(${phoneCode})${phoneNumber}`

                            let nextCode = value.slice(0, 9);
                            let phoneNumberCorrect = value.replace(nextCode, '-')
                            value = `${nextCode}${phoneNumberCorrect}`
                        }
                        this.shipping_info.shipping_phone_number = value

                        if (errors.response && errors.response.status === 500 && errors.response.data) {
                            for(let i = 0; i < errors.response.data.messages.length; i++) {
                                this.addNote({item: {message: errors.response.data.messages[i], type: 'error'}})
                            }
                            this.failedOrder = errors.response.data.order
                        }
                        this.loading(false)
                        return null
                    })
                }
            }
            else
            {
                this.loading(false)
                return null
            }

        },
        handleInputChange() {
            this.saveCart({page: 'checkout'})
        },
        numbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        capitalizeWords($event) {
            var words = $event.target.value.split(" ");
            for (var i = 0; i < words.length; i++) {
                var word = words[i];
                words[i] = word.charAt(0).toUpperCase() + word.slice(1);
            }
            return words.join(" ");
        },
        phoneInputFormatter($event) {
            let value = $event.target.value.replace(' ', '')

            if (!value.length ) {
                return ''
            }

            // if (value.includes('(') || value.includes(')') || value.includes('-')) {
            //     value = value.replace('(', '').replace(')', '').replace('-', '')
            // }
            value= value.replace(/[^0-9]/g,"");
            if(value.length >10)
            {
                value = value.slice(0,10);
            }

            let phoneCode = value.length > 3 ? '(' + value.slice(0, 3) + ')' : ''
            let phoneNumber = '', phoneFirstPart = '', phoneLastPart = ''
            if (phoneCode.length) {
                phoneNumber = value.slice(3)
                phoneFirstPart = ' ' + phoneNumber.slice(0, 3)

                if (phoneFirstPart.trim().length && phoneFirstPart.trim().length >= 3) {
                    phoneLastPart = phoneNumber.replace(phoneFirstPart.trim(), '')
                    phoneLastPart = phoneLastPart.length ? '-' + phoneLastPart : ''
                }
                value = `${phoneCode}${phoneFirstPart}${phoneLastPart}`
            }

            return value;
        },
        computedPhoneInputFormatter(value)
        {
            if (!value.length ) {
                return ''
            }

            // if (value.includes('(') || value.includes(')') || value.includes('-')) {
            //     value = value.replace('(', '').replace(')', '').replace('-', '')
            // }
            value= value.replace(/[^0-9]/g,"");
            if(value.length >10)
            {
                value = value.slice(0,10);
            }

            let phoneCode = value.length > 3 ? '(' + value.slice(0, 3) + ')' : ''
            let phoneNumber = '', phoneFirstPart = '', phoneLastPart = ''
            if (phoneCode.length) {
                phoneNumber = value.slice(3)
                phoneFirstPart = ' ' + phoneNumber.slice(0, 3)

                if (phoneFirstPart.trim().length && phoneFirstPart.trim().length >= 3) {
                    phoneLastPart = phoneNumber.replace(phoneFirstPart.trim(), '')
                    phoneLastPart = phoneLastPart.length ? '-' + phoneLastPart : ''
                }
                value = `${phoneCode}${phoneFirstPart}${phoneLastPart}`
            }

            return value;
        },
        submitButtonVisible(action) {
            if (action === 'credit_cart') {

                this.submitVisible = true
                $("#paymentOne").toggle();
                $("#paymentTwo").toggle();
            }
        }
    },
    beforeMount() {
        this.checkCartItems();
        if (!this.$store.state.shipping_methods.custom_price) {
            this.calcGroundFreight();
        }

        if(this.billing_info.billing_state && this.billing_info.billing_state.length == 2)
        {
            this.billing_info.billing_state = "";
        }

        if(this.shipping_info.shipping_state && this.shipping_info.shipping_state.length == 2)
        {
            this.shipping_info.shipping_state = "";
        }
    },
    async mounted() {
        // await this.saveCart({page: 'checkout'})
        // await this.checkCartItems();
        if((this.$store.state.cart.items && this.$store.state.cart.items.length) || this.propSharedcarthash)
        {
            this.billing_info.billing_phone_number = this.billing_info.billing_phone_number ? this.computedPhoneInputFormatter(this.billing_info.billing_phone_number) : "";
            this.shipping_info.shipping_phone_number = this.shipping_info.shipping_phone_number ? this.computedPhoneInputFormatter(this.shipping_info.shipping_phone_number) : "";
            if (!this.configs.usaepay.active) {
                this.submitVisible = false
            }

            this.$store.state.cart.appendurl = this.appendurl
            this.$store.state.cart.sharedCartHash = this.sharedcarthash ? this.sharedcarthash : this.$store.state.cart.sharedCartHash
            this.billing_info.read_and_accept = 1
            this.saveCart({page: 'checkout'})

            if (!this.$store.state.shipping_methods.custom_price) {
                this.calcGroundFreight();
            }
        }
        else
        {
            let queryStringSharedHash = this.hashshared ? '?cart='+ this.hashshared : "";
            window.location.href = window.location.origin+'/cart'+queryStringSharedHash;
        }
        if(this.billing_info.billing_zipcode == '00000')
            this.billing_info.billing_zipcode = "";
        if(this.shipping_info.shipping_zipcode == '00000')
            this.shipping_info.shipping_zipcode = "";
    },
    created() {
        this.checkCartItems();
        // if((this.$store.state.cart.items && this.$store.state.cart.items.length) || this.propSharedcarthash)
        // {
        // }
        // else
        // {
        //     window.location.href = window.location.origin+'/cart';

        // }
    }
}
</script>

<style scoped>
    .notVisible {
        display: none;
    }
    .payment-content {
        margin-left: auto;
        max-width: 100%;
        width: 70%;
    }
    .payment-options-title{
        margin-left: auto;
        max-width: 100%;
        width: 70%;
    }
    .payment-accordion-box label {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        padding: 17.5px 2em 17.5px 1em;
        color: #232323e0;
        background-color: #f2f2f2;
        display: inline-block;
        text-align: center;
        border-radius: 3px;
        position: relative;
        margin-bottom: 5px;
        margin-top: 13px;
        cursor: pointer;
        font-size: 20px;
        line-height: 1;
        width: 100%;
    }


    @media screen and (max-width: 767px)  {
        .payment-accordion-box label {
            color: #fff;
            background-color: #000;
            min-height: 58px;
            border-radius: 0;
            text-align: left;
            font-size: 16px;
        }
    }

    .payment-accordion-box label.collapsed::after {
        background-color: transparent;
        background-image: none;
        border-color: #9ba99f;
    }

    .payment-accordion-box label:after {
        position: absolute;
        content: '';
        right: 10px;
        width: 28px;
        height: 28px;
        background-color: #2683e5;
        background-image: url('images/icons/check.png');
        background-repeat: no-repeat;

        background-position: center;
        border:1px solid #2683e5;
        transition:  all .3s ease;
    }

    .payment-accordion-box .payment-accordion-form {
        background-color: #e5e5e5;
        padding: 2em 1em 1em;
        border-radius: 2px;
        position: relative;
        font-size: .92em;
        line-height: 1.5;
        color: #595959;
        margin: 1em 0;
    }
    .payment-accordion-box .payment-accordion-form:after {
        border: 8px solid #e5e5e5;
        border-right-color: transparent;
        border-left-color: transparent;
        border-top-color: transparent;
        margin: -1em 0 0 2em;
        position: absolute;
        display: block;
        content: "";
        right: 6px;
        top: -2px;
    }
    .payment-accordion-box .payment-accordion-form span {
        position: relative;
        width: fit-content;
        word-spacing: 2px;
        font-size: 13px;
        display: block;
        line-height: 2;
    }
    .payment-accordion-box .payment-accordion-form span sup {
        position: absolute;
        font-weight: 900;
        font-size: 13px;
        color: #FF6C6C;
        right: -12px;
        top: 12px;
    }
    .payment-accordion-box .payment-accordion-form input {
        border-color: #ccc;
        border-top-color: #bfbfbf;
        font-size: 1.5em;
        height: 42px;
        padding: 8px;
        width: 100%;
    }
    .payment-accordion-box .payment-accordion-form input::placeholder { color: #bfbfbf; }
    .payment-accordion-box .payment-accordion-form div {
        margin-bottom: 1em;
        padding: 3px 0;
    }
    a#place_order {
        padding: 11px 30px;
        margin-top: 33px;
    }
    div#paypal_btn { margin-top: 5px;margin-bottom: 11px; }
    @media screen and (max-width: 767px) {
        .payment-content {
            max-width: 100%;
            width: 100%;
        }
        .payment-options-title{
            max-width: 100%;
            width: 100%;
        }
    }
</style>
